export default "__VITE_ASSET__DX46AWQp__"